import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "aria-label": "Breadcrumb",
  class: "breadcrumb mobhide"
}
const _hoisted_2 = {
  key: 1,
  class: "breadcrumb-item not-clickable"
}
const _hoisted_3 = {
  key: 1,
  "aria-label": "Breadcrumb",
  class: "breadcrumb mobhide"
}
const _hoisted_4 = {
  key: 1,
  class: "breadcrumb-item not-clickable"
}

import { ref, watch, onMounted, toRefs, computed } from 'vue';
import type { Sibling } from '@/types';

interface Props {
  areaUrl?: string;
  communityUrl?: string;
  communityName?: string;
  communityEnabled?: boolean | string;
  isKioskMode: boolean;
  neighborhoods?: Sibling[];
  selectedNeighborhoodIds: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeaderBreadCrumb',
  props: {
    areaUrl: {},
    communityUrl: {},
    communityName: {},
    communityEnabled: { type: [Boolean, String] },
    isKioskMode: { type: Boolean },
    neighborhoods: { default: () => [] as Sibling[] },
    selectedNeighborhoodIds: {}
  },
  setup(__props: any) {

const props = __props;
const {
  areaUrl,
  communityUrl,
  communityName,
  communityEnabled,
  isKioskMode,
  neighborhoods,
  selectedNeighborhoodIds,
} = toRefs(props);

const selectedNeighborhoodData = ref<Sibling>({} as Sibling);

// API serialises community_enabled as a string ("true" / "false" / ""), so "false" must not be treated as truthy
const isCommunityLinkActive = computed(
  () => String(communityEnabled?.value) === 'true' && !!communityUrl?.value
);

// Fall back to community_url until the API exposing area_url is deployed
const communitiesUrl = computed(() => areaUrl?.value || communityUrl?.value || '');

watch([neighborhoods, selectedNeighborhoodIds], () => {
  setNeighborhoodInfo();
}, {
  deep: true
});

onMounted(() => {
  setNeighborhoodInfo();
});

const setNeighborhoodInfo = () => {
  if (selectedNeighborhoodIds.value.length) {
    const neighborhood = neighborhoods.value.find(
      (n) => n.id === selectedNeighborhoodIds.value[0]
    );
    selectedNeighborhoodData.value = neighborhood ?? ({} as Sibling);
  } else {
    selectedNeighborhoodData.value = {} as Sibling;
  }
};

const breadCrumbsNavigation = (path = '') => {
  if (path) window.open(path, '_blank');
};

return (_ctx: any,_cache: any) => {
  return (_unref(selectedNeighborhoodIds) && _unref(selectedNeighborhoodIds).length)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("a", {
          class: _normalizeClass([{ 'pointer-none': _unref(isKioskMode) }, 'breadcrumb-item']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (!_unref(isKioskMode) && breadCrumbsNavigation(communitiesUrl.value)))
        }, [...(_cache[5] || (_cache[5] = [
          _createTextVNode(" Communities", -1),
          _createElementVNode("span", null, null, -1)
        ]))], 2),
        (_unref(communityName) && isCommunityLinkActive.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: _normalizeClass([{ 'pointer-none': _unref(isKioskMode) }, 'breadcrumb-item']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (!_unref(isKioskMode) && breadCrumbsNavigation(_unref(communityUrl))))
            }, _toDisplayString(_unref(communityName)), 3))
          : (_unref(communityName))
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(communityName)), 1))
            : _createCommentVNode("", true),
        (selectedNeighborhoodData.value.neighborhood_name)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              class: "breadcrumb-item",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (
        !_unref(isKioskMode) &&
          breadCrumbsNavigation(selectedNeighborhoodData.value.neighborhood_url)
      ))
            }, _toDisplayString(selectedNeighborhoodData.value.neighborhood_name), 1))
          : _createCommentVNode("", true),
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "breadcrumb-item" }, "Home Sites", -1))
      ]))
    : (communitiesUrl.value)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
          _createElementVNode("a", {
            class: _normalizeClass([{ 'pointer-none': _unref(isKioskMode) }, 'breadcrumb-item']),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (!_unref(isKioskMode) && breadCrumbsNavigation(communitiesUrl.value)))
          }, " Communities ", 2),
          (_unref(communityName) && isCommunityLinkActive.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: _normalizeClass([{ 'pointer-none': _unref(isKioskMode) }, 'breadcrumb-item']),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (!_unref(isKioskMode) && breadCrumbsNavigation(_unref(communityUrl))))
              }, _toDisplayString(_unref(communityName)), 3))
            : (_unref(communityName))
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(communityName)), 1))
              : _createCommentVNode("", true),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "breadcrumb-item" }, "Home Sites", -1))
        ]))
      : _createCommentVNode("", true)
}
}

})